import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { PlayStoreBadge } from './PlayStoreBadge';
import { getPlayStoreUrl } from '../../config/urls';
import { Analytics } from '../../services/analytics';

export function Footer() {
  const playStoreUrl = getPlayStoreUrl();

  const handlePlayClick = () => {
    Analytics.track('landing_cta_play_click', {
      placement: 'footer',
      audience: 'driver'
    });
  };

  return (
    <footer className="py-12 sm:py-20 px-4 bg-[#081b1f] border-t border-white/10 relative overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#c99648]/40 to-transparent"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-6 tracking-tight text-white font-space">Keep PCNs under control.</h2>
        <p className="text-[#c8d2cf] mb-10 max-w-xl mx-auto text-lg">
          Download the Android driver app, or use FleetMode to bring ticket intake, liability, and deadlines into one workflow.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <PlayStoreBadge href={playStoreUrl || undefined} onClick={handlePlayClick} variant="light" />
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-slate-400 text-sm gap-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-md bg-white flex items-center justify-center shadow-md shadow-black/20 p-1">
              <Logo className="w-full h-full object-contain" />
            </div>
            <span className="font-mono">PCNGuard &copy; 2026</span>
          </div>
          <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-8 font-mono text-xs tracking-wider text-center md:text-left">
            <a href="mailto:info@pcnguard.co.uk" className="hover:text-[#d9a45b] transition-colors">info@pcnguard.co.uk</a>
            <Link to="/privacy" className="hover:text-[#d9a45b] transition-colors">PRIVACY</Link>
            <Link to="/terms" className="hover:text-[#d9a45b] transition-colors">TERMS</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
